/* Storefront rupee symbol — renders ₹ in place of the store's "Rs." money
   format (shop.money_format = "Rs. {{amount}}"), and drops the whole-rupee
   ".00" decimals so prices read ₹24,850 not ₹24,850.00 (design 03/04).

   STOPGAP, NOT the real fix: the correct, flash-free change is the admin
   money-format setting (Settings → General → Store currency → Change
   formatting → "₹{{amount_no_decimals}}"), which also fixes CHECKOUT and ORDER
   EMAILS — surfaces the theme cannot reach. This script only affects storefront
   text. See docs/HUMAN-CHECKLIST.md. When that setting is changed this file
   becomes a harmless no-op and can be removed.

   Scope: only "Rs." immediately followed by a digit becomes ₹, and only a
   trailing ".00" on a ₹ amount is dropped — a genuine paise value like
   ₹1,234.56 is left untouched, and prose is never rewritten unless it is
   literally a price. */
(() => {
  const RS = /Rs\. ?\s?(?=\d)/g;
  const ZERO = /(₹[\d,]+)\.00(?!\d)/g;
  const needs = (s) => s.indexOf('Rs.') !== -1 || s.indexOf('₹') !== -1;
  const convert = (s) => s.replace(RS, '₹').replace(ZERO, '$1');

  const swap = (root) => {
    if (root.nodeType === 3) {
      if (needs(root.nodeValue)) root.nodeValue = convert(root.nodeValue);
      return;
    }
    if (root.nodeType !== 1) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const hits = [];
    let n;
    while ((n = walker.nextNode())) if (needs(n.nodeValue)) hits.push(n);
    hits.forEach((t) => (t.nodeValue = convert(t.nodeValue)));
  };

  const run = () => swap(document.body);
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);

  // Section re-renders (cart drawer/page, quantity changes, load-more) inject
  // fresh server HTML that still carries "Rs." — catch those too.
  new MutationObserver((mutations) => {
    for (const m of mutations) m.addedNodes.forEach(swap);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
